import { useScrollAnimation } from "../../../hooks/useScrollAnimation";

const posts = [
  {
    id: 1,
    image: "https://public.readdy.ai/ai/img_res/7497332daab6ab54a3a86cacf767cd6a.jpg",
    alt: "Classic cheesesteak close up",
  },
  {
    id: 2,
    image: "https://readdy.ai/api/search-image?query=artisan%20sandwich%20shop%20interior%20warm%20moody%20lighting%20counter%20display%20deli%20meats%20fresh%20bread%20industrial%20chic%20brick%20walls%20pendant%20lights%20Philadelphia%20deli%20atmosphere%20editorial%20photography&width=600&height=600&seq=ig2&orientation=squarish",
    alt: "Inside the shop",
  },
  {
    id: 3,
    image: "https://readdy.ai/api/search-image?query=italian%20hoagie%20sandwich%20cross%20section%20sliced%20cured%20meats%20salami%20provolone%20fresh%20vegetables%20on%20rustic%20wood%20board%20overhead%20shot%20warm%20natural%20light%20food%20photography%20editorial%20appetizing&width=600&height=600&seq=ig3&orientation=squarish",
    alt: "Italian hoagie cross section",
  },
  {
    id: 4,
    image: "https://readdy.ai/api/search-image?query=hand%20breaded%20chicken%20cutlet%20sandwich%20sharp%20provolone%20long%20hot%20peppers%20broccoli%20rabe%20Italian%20roll%20golden%20fried%20crust%20warm%20light%20overhead%20food%20photography%20rustic%20surface%20editorial&width=600&height=600&seq=ig4&orientation=squarish",
    alt: "Chicken cutlet sandwich",
  },
  {
    id: 5,
    image: "https://readdy.ai/api/search-image?query=fresh%20bread%20baking%20artisan%20hoagie%20rolls%20golden%20crust%20warm%20out%20of%20the%20oven%20rustic%20bakery%20tray%20overhead%20photography%20warm%20tones%20natural%20light%20editorial%20food%20photography&width=600&height=600&seq=ig5&orientation=squarish",
    alt: "Fresh baked rolls",
  },
  {
    id: 6,
    image: "https://readdy.ai/api/search-image?query=roast%20pork%20Italian%20sandwich%20slow%20roasted%20pork%20shoulder%20sharp%20provolone%20broccoli%20rabe%20Italian%20long%20roll%20drizzled%20with%20garlic%20oil%20warm%20overhead%20food%20photography%20rustic%20wood%20surface%20editorial&width=600&height=600&seq=ig6&orientation=squarish",
    alt: "Roast pork Italian",
  },
];

export default function InstagramSection() {
  const [ref, visible] = useScrollAnimation();

  return (
    <section className="bg-[#fafafa] py-20">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        {/* Header */}
        <div
          ref={ref}
          className={`text-center mb-10 transition-all duration-700 ${
            visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"
          }`}
        >
          <p
            className="text-black/40 text-xs tracking-[0.3em] uppercase mb-3"
            style={{ fontFamily: "'Barlow', sans-serif" }}
          >
            Stay Connected
          </p>
          <h2
            className="text-black text-4xl md:text-5xl font-black uppercase leading-none mb-4"
            style={{ fontFamily: "'Barlow Condensed', sans-serif" }}
          >
            Follow Along
          </h2>
          <a
            href="https://instagram.com/phillysandoco"
            target="_blank"
            rel="nofollow"
            className="inline-flex items-center gap-2 text-black/60 hover:text-black transition-colors duration-200 cursor-pointer group"
            style={{ fontFamily: "'Barlow', sans-serif" }}
          >
            <span className="w-5 h-5 flex items-center justify-center">
              <i className="ri-instagram-line text-base"></i>
            </span>
            <span className="text-sm font-bold tracking-wide group-hover:underline underline-offset-2">
              @phillysandoco
            </span>
          </a>
        </div>

        {/* Photo Grid */}
        <div className="grid grid-cols-3 md:grid-cols-6 gap-2 md:gap-3">
          {posts.map((post, idx) => (
            <a
              key={post.id}
              href="https://instagram.com/phillysandoco"
              target="_blank"
              rel="nofollow"
              aria-label={post.alt}
              className={`block relative overflow-hidden rounded-sm group cursor-pointer transition-all duration-700 ${
                visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"
              }`}
              style={{ transitionDelay: `${idx * 80}ms`, transitionDuration: "600ms" }}
            >
              <div className="w-full aspect-square bg-[#ebebeb]">
                <img
                  src={post.image}
                  alt={post.alt}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              {/* Hover overlay */}
              <div className="absolute inset-0 bg-black/0 group-hover:bg-black/30 transition-all duration-300 flex items-center justify-center">
                <span className="w-8 h-8 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                  <i className="ri-instagram-line text-white text-xl"></i>
                </span>
              </div>
            </a>
          ))}
        </div>

        {/* CTA */}
        <div className="text-center mt-10">
          <a
            href="https://instagram.com/phillysandoco"
            target="_blank"
            rel="nofollow"
            className="inline-flex items-center gap-2.5 border border-black text-black text-xs tracking-[0.2em] uppercase font-bold px-8 py-4 hover:bg-black hover:text-white transition-all duration-200 cursor-pointer whitespace-nowrap rounded-sm"
            style={{ fontFamily: "'Barlow', sans-serif" }}
          >
            <span className="w-4 h-4 flex items-center justify-center">
              <i className="ri-instagram-line text-sm"></i>
            </span>
            Follow Us on Instagram
          </a>
        </div>
      </div>
    </section>
  );
}
